import { render, staticRenderFns } from "./ObstacleCard.vue?vue&type=template&id=3e2da245&scoped=true"
import script from "./ObstacleCard.vue?vue&type=script&lang=js"
export * from "./ObstacleCard.vue?vue&type=script&lang=js"
import style0 from "./ObstacleCard.vue?vue&type=style&index=0&id=3e2da245&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2da245",
  null
  
)

export default component.exports